import { useEffect, useState } from 'react';

import { IDirection } from '../../../../hooks/useSortableData';
import { ITableOptions } from '..';

const useDefaultSort = (
  requestSort: (key: string | number | symbol, dir?: IDirection) => void,
  options?: ITableOptions | null
) => {
  // Prevents infinite loop
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (options?.defaultKey && !hasLoaded) {
      setHasLoaded(true);

      requestSort(
        options.defaultKey,
        options?.defaultSortDirection || 'ascending'
      );
    }
  }, [
    hasLoaded,
    options?.defaultKey,
    options?.defaultSortDirection,
    requestSort,
  ]);
};

export default useDefaultSort;
